<template>
  <div id='app'>
    <loading :active.sync="isLoading"></loading>
    <header-view/>
    <!-- Keyword description modal -->


<modal v-show="modalVisible" @close="closeModal">
  <template v-slot:body>
    <div ref="keywordBody" id="keywordBody" tabindex="-1" v-html="tooltipText"></div>
  </template>
</modal>


    <coverageDetailsModal v-show='coverageDetailsVisible' @close='closeCoverageDetails'>
      <template #title>
        <div id="coverageDetailsTitle" tabindex="-1"></div>
      </template>

      <template #description>
        <div id="coverageDetailsDescription"></div>
      </template>

      <template #productcode>
        <div id="coverageDetailsProductCode" style="display:none;"></div>
      </template>
    </coverageDetailsModal>
    <stepwrapper-view/>
    <footer-view/>
  </div>
</template>

<script lang='js'>
import { iePolyfills } from "./utils/polyfills.js";
import getLocale from "./utils/getLocale";

import modal from "./components/Modal.vue";
import coverageDetailsModal from "./components/CoverageDetails.vue";
import { validationRules } from "./utils/validation_rules.js";
import { validateBirthDate, validateDepartureDate, validateReturnDate, validateTripCost, validateOldestTraveller, validateCoverageStartDate, validateEmail } from "./utils/validation_custom.js";
import { validateForm, validateField, setError } from "./utils/validation.js";
import bus from "./utils/bus.js";
import { eventPageView, addError, setLastPage } from "./utils/adobeAnalytics.js";
import setActiveProduct from "./utils/setActiveProduct.js";
import requestOffers from "./utils/requestOffers.js"
import requestPurchase from "./utils/requestPurchase.js"
import { updateCertificateLinks } from "./utils/updateCertificateLinks.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  components: {
    modal,
    coverageDetailsModal,
    Loading
  },
  data(){
    return {
      focusBack: null,
      coverageDetailsVisible: false,
      modalVisible: false,
      isLoading: false,
      tooltipText: ''
    }
  },
  created(){
        
    bus.$on("openModal", (text) => {
      this.modalVisible = true;
      this.focusBack = document.activeElement;
      document.body.classList.add("modal-open");
      this.tooltipText = text;
      this.$nextTick(() => {
        console.log('Conteúdo do tooltipText no DOM:', this.$refs.keywordBody.innerHTML);
        const keywordBody = this.$refs.keywordBody; // Use ref on template
        if (keywordBody) {
          const targetLinks = keywordBody.querySelectorAll("a[data-product]");
          for (const link of targetLinks) {
            const clientCode = this.$store.state.site === "cibc" ? "CIBC" : "CIBCIndividual";
            const url = `${window.location.origin}/${getLocale(true)}/api/certificate/${clientCode}/${link.getAttribute("data-product")}`;
            link.addEventListener("click", () => this.openInNewWindow(url));
          }
        }
      });

      // Focus inside new Modal popup.
      this.$nextTick(() => {
        const keywordBodyForFocus = this.$refs.keywordBody;
        if (keywordBodyForFocus) {
          keywordBodyForFocus.focus();
        }
      });
    });

    bus.$on("openCoverageDetails", (product) => {
      document.getElementsByTagName("body")[0].classList.add("modal-open");
      this.coverageDetailsVisible=true;
      this.focusBack=document.activeElement;
      const btnCDSelect = document.getElementById("btnCDSelect");
      if(btnCDSelect){
        btnCDSelect.setAttribute("data-product",product.Product.ProductCode);
      }
      
      const coverageDetailsTitle = document.getElementById("coverageDetailsTitle");
      if (coverageDetailsTitle) {
        coverageDetailsTitle.innerHTML = product.Product.Name;
      }
      
      const coverageDetailsProductCode = document.getElementById("coverageDetailsProductCode");
      if (coverageDetailsProductCode) {
        coverageDetailsProductCode.innerHTML = product.Product.ProductCode;
      }

      const elements = [
        "cd_medical", "cd_tripcancel", "convenience1", "convenience2", 
        "convenience3", "convenience4", "convenience5"
      ];
      
      elements.forEach(elementId => {
        const element = document.getElementById(elementId);
        if (element) {
          element.style.display = "none";
        }
      });

      if(product.Product.ProductCode==="CIBCMedicalPlan"||product.Product.ProductCode==="CIBCIMedicalPlan"||
        product.Product.ProductCode==="CIBCAnnual8Day"||product.Product.ProductCode==="CIBCIAnnual8Day"||
        product.Product.ProductCode==="CIBCAnnual18Day"||product.Product.ProductCode==="CIBCIAnnual18Day"||
        product.Product.ProductCode==="CIBCComprehensive"||product.Product.ProductCode==="CIBCIComprehensive"){
        const cdMedical = document.getElementById("cd_medical");
        const convenience1 = document.getElementById("convenience1");
        const convenience5 = document.getElementById("convenience5");
        
        if (cdMedical) cdMedical.style.display = "block";
        if (convenience1) convenience1.style.display = "flex";
        if (convenience5) convenience5.style.display = "flex";
      }

      if(product.Product.ProductCode==="CIBCTripProTripCan"||product.Product.ProductCode==="CIBCITripProTripCan"||
        product.Product.ProductCode==="CIBCComprehensive"||product.Product.ProductCode==="CIBCIComprehensive"){
        const cdTripcancel = document.getElementById("cd_tripcancel");
        const convenience2 = document.getElementById("convenience2");
        const convenience3 = document.getElementById("convenience3");
        const convenience4 = document.getElementById("convenience4");
        
        if (cdTripcancel) cdTripcancel.style.display = "block";
        if (convenience2) convenience2.style.display = "flex";
        if (convenience3) convenience3.style.display = "flex";
        if (convenience4) convenience4.style.display = "flex";
      }
      
      
      // Focus inside new Modal popup.
      this.$nextTick (() => {
        const coverageDetailsTitleFocus = document.getElementById("coverageDetailsTitle");
        if (coverageDetailsTitleFocus) {
          coverageDetailsTitleFocus.focus();
        }
      });
    });
    bus.$on("updateProducts", (payload, language) => {
      for(const category in payload){
        for(const product in payload[category].Products){
          let currentBenefit=0;
          payload[category].Products[product].Product.BenefitsDetails=[];
          for(const benefit in payload[category].Products[product].Product.Benefits){
            if(payload[category].Products[product].Product.Benefits[benefit].Name==="Travel Medical Insurance Coverage"){
              payload[category].Products[product].Product.BenefitsDetails[currentBenefit]=this.$t("text.benefit1");
              currentBenefit++;
              payload[category].Products[product].Product.BenefitsDetails[currentBenefit]=this.$t("text.benefit2");
              currentBenefit++;
            }
            else if(benefit==="0") {
              payload[category].Products[product].Product.BenefitsDetails[currentBenefit]=this.$t("text.benefit2");
              currentBenefit++;
            }
            
            if(payload[category].Products[product].Product.Benefits[benefit].Name==="Trip Cancellation"||
              payload[category].Products[product].Product.Benefits[benefit].Name==="Annulation de voyage"){
              payload[category].Products[product].Product.BenefitsDetails[currentBenefit]=this.$t("text.benefit3");
              currentBenefit++;
            }
          }
        }
      }
      this.$store.commit("updateProducts", payload, language);
      if(this.$store.state.product!==""){
        this.$nextTick(() => {
          setActiveProduct(this,this.$store.state.product.Product.ProductCode);
        });
      }
      // This code refreshes the Quote page (if language was just changed)
      if(this.$route.path==="/Quote"){
        this.$nextTick(() => {
          this.$router.push({ name: "Reload", params: { target: this.$route.path }});
        });
      } else if (this.$route.path==="/PaymentInfo"){
        updateCertificateLinks(this);
      }
    });
    bus.$on("updatePolicyNumber", (payload) => {
      this.$store.commit("updatePolicyNumber", payload);
    });
    bus.$on("hideLoading", (loading) => {
      this.isLoading=false;
    });
    bus.$on("APIError", (errorCode) => {
      addError("API",errorCode,"API Error");
      if(this.$store.state.site==="cibc"){
        alert(this.$t("text.invalid_APIResponse")+" "+errorCode);
      }
      else {
        alert(this.$t("text.invalid_APIResponse")+" "+errorCode);
      }
    });
    bus.$on("setSurvey", (responseText) =>{
      this.$store.commit("setSurvey", responseText);
      // This code refreshes the Quote page (if language was just changed)
      if(this.$route.path==="/Questionnaire2"||this.$route.path==="/Questionnaire3"){
        this.$nextTick(() => {
          this.$router.push({ name: "Reload", params: { target: this.$route.path }});
        });
      };
    });
    bus.$on("sendOfferRequest", (options) => {
      // Options will be either:
      // A boolean which determines if the Offer should be routed to the Quote page after results are returned.
      // Or, it will be the Medical Survey results, which should be appended to the Offer.
      const offerRequest = this.$store.state.offerRequest;
      let productAlreadySelected=false;
      if(options&&options===true){      
        productAlreadySelected=true;
      }
      else if(options&&options!==""){
        this.$store.commit("setScore",options);
        offerRequest.Coverage.Insured[0].MedicalSurvey.SurveyScore=options.Score;
        offerRequest.Coverage.Insured[0].MedicalSurvey.ScoringReference=options.ScoringReference;
        offerRequest.Coverage.Insured[0].MedicalSurvey.VerificationToken=options.ValidationToken;
      }
      if(productAlreadySelected===false){
        this.$store.state.offerRequest.getOffer(
          function callbackChangeStep(status, responseText) {
            if(status===200){
              if(typeof responseText.OfferCategories[0]!== "undefined"){
                const payload = responseText.OfferCategories;
                bus.$emit("updateProducts", payload);
                bus.$emit("changeStep", "", "/Quote", false, true);
              }
              else {
                bus.$emit("APIError", "RWEC0002");
              }
            }
            else {
              bus.$emit("APIError", "RWEC0001");
            }
            bus.$emit("hideLoading");
          });
      } else {
        this.$store.state.offerRequest.getOffer(
          function callbackChangeStep(status, responseText) {
            if(status===200){
              if(typeof responseText.OfferCategories[0]!== "undefined"){
                const payload = responseText.OfferCategories;
                bus.$emit("updateProducts", payload);
              }
              else {
                bus.$emit("APIError", "RWEC0002");
              }
            }
            else {
              bus.$emit("APIError", "RWEC0001");
            }
            bus.$emit("hideLoading");
          });
      }
    });
    bus.$on("setError", (targetField, errorMessage) => {
      setError(targetField, this.$t("text."+errorMessage));
    });
    // Called when the step/page is moved forward or backward. This runs validation on the fields, and commits the values to the Store.
    bus.$on("changeStep", (from, to, doValidation, requestProcessed=false) => {
      // Validate that we have a valid destination
      if (!to || to === "" || to === "undefined") {
        console.error("Invalid navigation target:", to);
        return;
      }
      
      this.$store.commit("beginValidation");
      
      const getDatepickerElement = (fieldId) => {
        const root = document.getElementById(fieldId);
        if (!root) {
          return null;
        }
        const input = root.querySelector("input.dp__input");
        if (input && input.id !== fieldId) {
          input.id = fieldId;
        }
        return input || root;
      };

      const getDatepickerValue = (fieldId) => {
        const element = getDatepickerElement(fieldId);
        return element && typeof element.value === "string" ? element.value : "";
      };

      let isValid=true;

      if(doValidation===true) {
        // Run the general form validation.
        if(validateForm(validationRules())===false) {isValid=false;}
        // Run check to confirm that age of oldest traveller & total cost of trip are valid
        else if(this.$route.name==="TravelPlans"){
          const oldestTravellerEl = document.getElementById("oldestTraveller");
          const oldestTravellerValue = oldestTravellerEl ? oldestTravellerEl.value : '';
          if((validateOldestTraveller(oldestTravellerValue,this.$store.state.wantsMedical,this.$store.state.site)===false||validateTripCost(this.$store.state.site)===false||validateDepartureDate()===false||validateReturnDate()===false)){
            isValid=false;
          }
        }
        // Run check to confirm that Date of Births entered do not violate the rules
        else if(this.$route.name==="TravellerAges") {
          // This check confirms there are not multiple travellers if any of them require a medical questionnaire
          if(this.$store.state.wantsMedical===true&&this.$store.state.numberOfTravellers>1) {
            const inputList = document.getElementsByTagName("input");
            for(const input in inputList) {
              if(inputList[input].offsetWidth!==0&&Math.abs(this.$moment(inputList[input].value, "MM/DD/YYYY").diff(this.$moment(), "years"))>=60) {
                to="/TravelPlans";
              }
            }
          }
          // This check confirms there a 90+ birthdate wasn't entered if there are no medical products to display.
          else if(this.$store.state.wantsMedical===false) {
            const inputList = document.getElementsByTagName("input");
            for(const input in inputList) {
              if(inputList[input].offsetWidth!==0&&Math.abs(this.$moment(inputList[input].value, "MM/DD/YYYY").diff(this.$moment(), "years"))>=90) {
                isValid=false;
              }
            }
          }
          // Run custom date of birth validation
          for(let i=1; i<=10;i++){
            if(i<=this.$store.state.numberOfTravellers){
              const travellerDobEl = document.getElementById("traveller"+i+"_dob");
              if(travellerDobEl && validateBirthDate(travellerDobEl, travellerDobEl.value, this.$store.state.wantsMedical)===false){
                isValid=false;
              }
            }
          }
        }
        else if(this.$route.name==="ApplicantInfo"){
          if(this.$store.state.product.ProductCode==="CIBCAnnual8Day"||
          this.$store.state.product.ProductCode==="CIBCAnnual18Day"||
          this.$store.state.product.ProductCode==="CIBCIAnnual8Day"||
          this.$store.state.product.ProductCode==="CIBCIAnnual18Day"){
            if(validateCoverageStartDate()===false||validateEmail()===false){
              isValid=false;
            }
          } else {
            if(validateEmail()===false){
              isValid=false;
            }
          }
        }
      }

      // If everything is valid, update the store
      if (isValid===true) {
        let payload= {};
        // If this is the Offer Request, 
        if(to==="/Quote"&&from!=="/Notices"&&requestProcessed===false) {
          requestOffers(this);
          return false;
        }
        // If this is the Purchase Request, 
        else if(this.$route.name==="PaymentInfo"&&to==="/Confirmation"&&requestProcessed===false) {
          requestPurchase(this);
          return false;
        }
        // Set payload to fields for the current page.
        else if(this.$route.name==="TypeOfCoverage"){
          const wantsCancellationEl = document.getElementById("wantsCancellation");
          const wantsMedicalEl = document.getElementById("wantsMedical");
          payload = {
            wantsCancellation: wantsCancellationEl ? wantsCancellationEl.checked : false,
            wantsMedical: wantsMedicalEl ? wantsMedicalEl.checked : false
          };
        } 
        else if (this.$route.name==="TravelPlans"){
          const numberOfTravellersEl = document.getElementById("numberOfTravellers");
          const oldestTravellerEl = document.getElementById("oldestTraveller");
          const departureDateEl = getDatepickerElement("departureDate");
          const returnDateEl = getDatepickerElement("returnDate");
          const tripCostEl = document.getElementById("tripCost");
          const provinceEl = document.getElementById("province");
          
          let tripStart="";
          const departureDateValue = departureDateEl && typeof departureDateEl.value === "string" ? departureDateEl.value : "";
          if(departureDateValue && this.$moment(departureDateValue, "MM/DD/YYYY").diff(this.$moment(), "days")<=30){
            tripStart = departureDateValue;
          } 
          const returnDateValue = returnDateEl && typeof returnDateEl.value === "string" ? returnDateEl.value : "";
          
          payload = {
            numberOfTravellers: numberOfTravellersEl ? numberOfTravellersEl.value : '',
            oldestTraveller_dob: getDatepickerValue("oldestTraveller_dob"),
            oldestTraveller: oldestTravellerEl ? oldestTravellerEl.value : '',
            departureDate: departureDateValue,
            returnDate: returnDateValue,
            tripCost: tripCostEl ? tripCostEl.value : '',
            tripStart,
            province: provinceEl ? provinceEl.options[provinceEl.selectedIndex].value : '',
          }
        } else if (this.$route.name==="TravellerAges"){
          let targetTraveller=0;
          let newOldestTraveller = this.$store.state.oldestTraveller_dob;
          if(this.$moment(document.getElementById("traveller1_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=1;
            newOldestTraveller=document.getElementById("traveller1_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=2&&this.$moment(document.getElementById("traveller2_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=2;
            newOldestTraveller=document.getElementById("traveller2_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=3&&this.$moment(document.getElementById("traveller3_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=3;
            newOldestTraveller=document.getElementById("traveller3_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=4&&this.$moment(document.getElementById("traveller4_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=4;
            newOldestTraveller=document.getElementById("traveller4_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=5&&this.$moment(document.getElementById("traveller5_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=5;
            newOldestTraveller=document.getElementById("traveller5_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=6&&this.$moment(document.getElementById("traveller6_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=6;
            newOldestTraveller=document.getElementById("traveller6_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=7&&this.$moment(document.getElementById("traveller7_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=7;
            newOldestTraveller=document.getElementById("traveller7_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=8&&this.$moment(document.getElementById("traveller8_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=8;
            newOldestTraveller=document.getElementById("traveller8_dob").value;
          } 
          if(this.$store.state.numberOfTravellers>=9&&this.$moment(document.getElementById("traveller9_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=9;
            newOldestTraveller=document.getElementById("traveller9_dob").value;
          } 
          if(this.$store.state.numberOfTravellers===10&&this.$moment(document.getElementById("traveller10_dob").value,"MM/DD/YYYY")<this.$moment(newOldestTraveller,"MM/DD/YYYY")){
            targetTraveller=10;
            newOldestTraveller=document.getElementById("traveller10_dob").value;
          }

          if(targetTraveller===1){
            this.$store.state.oldestTraveller_isPrimary=true;
          } else if(targetTraveller===2) {
            this.$store.state.oldestTraveller_isPrimary=false;
          } else if(targetTraveller>2) {
            this.$store.state.oldestTraveller_isPrimary=false;
            const temp = document.getElementById("traveller2_dob").value;
            document.getElementById("traveller2_dob").value = document.getElementById("traveller"+targetTraveller+"_dob").value;
            document.getElementById("traveller"+targetTraveller+"_dob").value = temp;
          }

          const age = this.$moment(this.$store.state.departureDate,"MM/DD/YYYY").diff(this.$moment(newOldestTraveller,"MM/DD/YYYY"), "years", false);

          if(age>59&&this.$store.state.wantsMedical===true&&this.$store.state.numberOfTravellers>1){
            this.$store.state.numberOfTravellers=1;
          }

          payload = {
            oldestTraveller_dob: newOldestTraveller,
            traveller1_dob: document.getElementById("traveller1_dob").value,
            traveller2_dob: document.getElementById("traveller2_dob").value,
            traveller3_dob: document.getElementById("traveller3_dob").value,
            traveller4_dob: document.getElementById("traveller4_dob").value,
            traveller5_dob: document.getElementById("traveller5_dob").value,
            traveller6_dob: document.getElementById("traveller6_dob").value,
            traveller7_dob: document.getElementById("traveller7_dob").value,
            traveller8_dob: document.getElementById("traveller8_dob").value,
            traveller9_dob: document.getElementById("traveller9_dob").value,
            traveller10_dob: document.getElementById("traveller10_dob").value,
          }
        } else if (this.$route.name==="Questionnaire1"){
          let confirmEligibilityValid;
          if (document.getElementById("mq1y").checked === true) {
            confirmEligibilityValid = true;
          } else if (document.getElementById("mq1n").checked === true) {
            confirmEligibilityValid = false;
          }
          payload = {
            confirmEligibility: confirmEligibilityValid,
          }
        } else if (this.$route.name==="Questionnaire2"){
          let medicalQuestion2Valid;
          let medicalQuestion3Valid;
          let medicalQuestion4Valid;
          let medicalQuestion5Valid;
          let medicalQuestion6Valid;
          let medicalQuestion7Valid;
          let medicalQuestion8Valid;
          let medicalQuestion9Valid;
          let medicalQuestion10Valid;
          let medicalQuestion11Valid;
          if (document.getElementById("mq2y").checked === true) {
            medicalQuestion2Valid = true;
          } else if (document.getElementById("mq2n").checked === true) {
            medicalQuestion2Valid = false;
          }
          if (document.getElementById("mq3y").checked === true) {
            medicalQuestion3Valid = true;
          } else if (document.getElementById("mq3n").checked === true) {
            medicalQuestion3Valid = false;
          }
          if (document.getElementById("mq4y").checked === true) {
            medicalQuestion4Valid = true;
          } else if (document.getElementById("mq4n").checked === true) {
            medicalQuestion4Valid = false;
          }
          if (document.getElementById("mq5y").checked === true) {
            medicalQuestion5Valid = true;
          } else if (document.getElementById("mq5n").checked === true) {
            medicalQuestion5Valid = false;
          }
          if (document.getElementById("mq6y").checked === true) {
            medicalQuestion6Valid = true;
          } else if (document.getElementById("mq6n").checked === true) {
            medicalQuestion6Valid = false;
          }
          if (document.getElementById("mq7y").checked === true) {
            medicalQuestion7Valid = true;
          } else if (document.getElementById("mq7n").checked === true) {
            medicalQuestion7Valid = false;
          }
          if (document.getElementById("mq8y").checked === true) {
            medicalQuestion8Valid = true;
          } else if (document.getElementById("mq8n").checked === true) {
            medicalQuestion8Valid = false;
          }
          if (document.getElementById("mq9y").checked === true) {
            medicalQuestion9Valid = true;
          } else if (document.getElementById("mq9n").checked === true) {
            medicalQuestion9Valid = false;
          }
          if (document.getElementById("mq10y").checked === true) {
            medicalQuestion10Valid = true;
          } else if (document.getElementById("mq10n").checked === true) {
            medicalQuestion10Valid = false;
          }
          if (document.getElementById("mq11y").checked === true) {
            medicalQuestion11Valid = true;
          } else if (document.getElementById("mq11n").checked === true) {
            medicalQuestion11Valid = false;
          }
          payload = {
            medicalQuestion2: medicalQuestion2Valid,
            medicalQuestion3: medicalQuestion3Valid,
            medicalQuestion4: medicalQuestion4Valid,
            medicalQuestion5: medicalQuestion5Valid,
            medicalQuestion6: medicalQuestion6Valid,
            medicalQuestion7: medicalQuestion7Valid,
            medicalQuestion8: medicalQuestion8Valid,
            medicalQuestion9: medicalQuestion9Valid,
            medicalQuestion10: medicalQuestion10Valid,
            medicalQuestion11: medicalQuestion11Valid,
          }
        } else if (this.$route.name==="Questionnaire3"){
          let medicalQuestion12Valid;
          let medicalQuestion13Valid;
          let medicalQuestion14Valid;
          let medicalQuestion15Valid;
          let medicalQuestion16Valid;
          let medicalQuestion17Valid;
          let medicalQuestion18Valid;
          let medicalQuestion19Valid;
          let medicalQuestion20Valid;
          let medicalQuestion21Valid;
          let medicalQuestion22Valid;
          let medicalQuestion23Valid;
          let medicalQuestion24Valid;
          let medicalQuestion25Valid;
          // let medicalQuestion26Valid;
          if (document.getElementById("mq12y").checked === true) {
            medicalQuestion12Valid = true;
          } else if (document.getElementById("mq12n").checked === true) {
            medicalQuestion12Valid = false;
          }
          if (document.getElementById("mq13y").checked === true) {
            medicalQuestion13Valid = true;
          } else if (document.getElementById("mq13n").checked === true) {
            medicalQuestion13Valid = false;
          }
          if (document.getElementById("mq14y").checked === true) {
            medicalQuestion14Valid = true;
          } else if (document.getElementById("mq14n").checked === true) {
            medicalQuestion14Valid = false;
          }
          if (document.getElementById("mq15y").checked === true) {
            medicalQuestion15Valid = true;
          } else if (document.getElementById("mq15n").checked === true) {
            medicalQuestion15Valid = false;
          }
          if (document.getElementById("mq16y").checked === true) {
            medicalQuestion16Valid = true;
          } else if (document.getElementById("mq16n").checked === true) {
            medicalQuestion16Valid = false;
          }
          if (document.getElementById("mq17y").checked === true) {
            medicalQuestion17Valid = true;
          } else if (document.getElementById("mq17n").checked === true) {
            medicalQuestion17Valid = false;
          }
          if (document.getElementById("mq18y").checked === true) {
            medicalQuestion18Valid = true;
          } else if (document.getElementById("mq18n").checked === true) {
            medicalQuestion18Valid = false;
          }
          if (document.getElementById("mq19y").checked === true) {
            medicalQuestion19Valid = true;
          } else if (document.getElementById("mq19n").checked === true) {
            medicalQuestion19Valid = false;
          }
          if (document.getElementById("mq20y").checked === true) {
            medicalQuestion20Valid = true;
          } else if (document.getElementById("mq20n").checked === true) {
            medicalQuestion20Valid = false;
          }
          if (document.getElementById("mq21y").checked === true) {
            medicalQuestion21Valid = true;
          } else if (document.getElementById("mq21n").checked === true) {
            medicalQuestion21Valid = false;
          }
          if (document.getElementById("mq22y").checked === true) {
            medicalQuestion22Valid = true;
          } else if (document.getElementById("mq22n").checked === true) {
            medicalQuestion22Valid = false;
          }
          if (document.getElementById("mq23y").checked === true) {
            medicalQuestion23Valid = true;
          } else if (document.getElementById("mq23n").checked === true) {
            medicalQuestion23Valid = false;
          }
          if (document.getElementById("mq24y").checked === true) {
            medicalQuestion24Valid = true;
          } else if (document.getElementById("mq24n").checked === true) {
            medicalQuestion24Valid = false;
          }
          if (document.getElementById("mq25y").checked === true) {
            medicalQuestion25Valid = true;
          } else if (document.getElementById("mq25n").checked === true) {
            medicalQuestion25Valid = false;
          }

          payload = {
            medicalQuestion12: medicalQuestion12Valid,
            medicalQuestion13: medicalQuestion13Valid,
            medicalQuestion14: medicalQuestion14Valid,
            medicalQuestion15: medicalQuestion15Valid,
            medicalQuestion16: medicalQuestion16Valid,
            medicalQuestion17: medicalQuestion17Valid,
            medicalQuestion18: medicalQuestion18Valid,
            medicalQuestion19: medicalQuestion19Valid,
            medicalQuestion20: medicalQuestion20Valid,
            medicalQuestion21: medicalQuestion21Valid,
            medicalQuestion22: medicalQuestion22Valid,
            medicalQuestion23: medicalQuestion23Valid,
            medicalQuestion24: medicalQuestion24Valid,
            medicalQuestion25: medicalQuestion25Valid,
            confirmMedical: document.getElementById("confirmMedical").checked,
          }
        } else if(this.$route.name==="Notices"){
          let confirmNoticeValid;
          if (document.getElementById("cn1y").checked === true) {
            confirmNoticeValid = true;
          } else if (document.getElementById("cn1n").checked === true) {
            confirmNoticeValid = false;
          }
          payload = {
            confirmNotice: confirmNoticeValid,
          };
        } else if (this.$route.name==="ApplicantInfo") {
          let fulfillmentValue;
          if (document.getElementById("cm1").checked === true&&document.getElementById("email").value!=="") {
            fulfillmentValue = "email";
          } else if(document.getElementById("cm3").checked === true&&document.getElementById("email").value!=="") {
            fulfillmentValue = "both";
          } else {
            fulfillmentValue = "mail";
          }
           const tripStartEl = getDatepickerElement("tripStart");

          payload = {
            tripStart: tripStartEl ? tripStartEl.value : '',
            traveller1_firstname: document.getElementById("traveller1_firstname").value,
            traveller1_lastname: document.getElementById("traveller1_lastname").value,
            address1: document.getElementById("address1").value,
            address2: document.getElementById("address2").value,
            city: document.getElementById("city").value,
            postalcode: document.getElementById("postalcode").value,
            phone: document.getElementById("phone").value,
            email: document.getElementById("email").value,
            province: document.getElementById("province").value,
            confirmCASL: document.getElementById("confirmCASL").checked,
            fulfillment: fulfillmentValue
          }
        } else if (this.$route.name==="TravellerInfo"){
          payload = {
            traveller2_firstname: document.getElementById("traveller2_firstname").value,
            traveller2_lastname: document.getElementById("traveller2_lastname").value,
            traveller3_firstname: document.getElementById("traveller3_firstname").value,
            traveller3_lastname: document.getElementById("traveller3_lastname").value,
            traveller4_firstname: document.getElementById("traveller4_firstname").value,
            traveller4_lastname: document.getElementById("traveller4_lastname").value,
            traveller5_firstname: document.getElementById("traveller5_firstname").value,
            traveller5_lastname: document.getElementById("traveller5_lastname").value,
            traveller6_firstname: document.getElementById("traveller6_firstname").value,
            traveller6_lastname: document.getElementById("traveller6_lastname").value,
            traveller7_firstname: document.getElementById("traveller7_firstname").value,
            traveller7_lastname: document.getElementById("traveller7_lastname").value,
            traveller8_firstname: document.getElementById("traveller8_firstname").value,
            traveller8_lastname: document.getElementById("traveller8_lastname").value,
            traveller9_firstname: document.getElementById("traveller9_firstname").value,
            traveller9_lastname: document.getElementById("traveller9_lastname").value,
            traveller10_firstname: document.getElementById("traveller10_firstname").value,
            traveller10_lastname: document.getElementById("traveller10_lastname").value,
          }
        } else if(this.$route.name==="PaymentInfo"){
           payload = {
            creditcard: document.getElementById("creditcard").value,
            creditcard_name: document.getElementById("creditcard_name").value,
            expiration: document.getElementById("expiration").value,
            creditcard_cvv: document.getElementById("creditcard_cvv").value,
            confirmTerms: document.getElementById("confirmTerms").checked,            
            confirmTermsPrivacyPolicy: document.getElementById("confirmTermsPrivacyPolicy").checked,
            renewAutomatically: document.getElementById("renewAutomatically").checked
          };
        }       
        // Set values always present in payload, regardless of step
        payload.page=this.$route.name;
        payload.didValidation=doValidation;

        payload.currentPage=to;
        // Adobe Analytics *START*
        setLastPage();
        // *END*

        // Safe router navigation with error handling
        if (this.$router && typeof this.$router.push === 'function') {
          try {
            this.$router.push(to);
          } catch (error) {
            console.error('Router navigation error:', error);
            // Fallback to direct navigation
            window.location.href = to;
          }
        }
        
        this.$store.commit("changeStep", payload);
        
        // Adobe Analytics *START*
        this.$nextTick(()=>{
          eventPageView(this, to);
        });
        // *END*
      }
      else {
        if(document.getElementsByClassName("invalid-feedback").length>0){
          document.getElementById(document.getElementsByClassName("invalid-feedback")[0].getAttribute("for")).focus();
        }
        else if(document.querySelectorAll("[aria-invalid='true']").length>0) {
          document.querySelectorAll("[aria-invalid='true']")[0].focus();
        }
      }
    });
  },
  mounted(){
    iePolyfills();

    const parseHashQuery = () => {
      if (typeof window === "undefined") {
        return {};
      }

      const hash = window.location.hash || "";
      const queryIndex = hash.indexOf("?");
      if (queryIndex < 0) {
        return {};
      }

      const params = new URLSearchParams(hash.slice(queryIndex + 1));
      const result = {};
      params.forEach((value, key) => {
        result[key] = value;
      });
      return result;
    };

    const hasQuery = (query) => query && Object.keys(query).length > 0;
    const preservedQuery = hasQuery(this.$route.query)
      ? this.$route.query
      : parseHashQuery();

    if (hasQuery(preservedQuery) && !hasQuery(this.$route.query)) {
      this.$router.replace({ path: this.$route.path, query: preservedQuery });
    }
    
    // If this is a fresh load of page, ensure it is routed to first page.
    if(this.$route.name!=="BeforeYouTravel"&&this.$route.name!=="Reload") {
      if (this.$router && typeof this.$router.push === 'function') {
        try {
          this.$router.push({ path: "/", query: preservedQuery });
        } catch (error) {
          console.error('Initial router navigation error:', error);
          const queryString = hasQuery(preservedQuery)
            ? `?${new URLSearchParams(preservedQuery).toString()}`
            : "";
          window.location.href = `${window.location.pathname}#/${queryString}`;
        }
      }
    }

    this.updateNavButtons(this.$route.path);
    
    // This listener insures that tab only works within modal if it is open, and Esc closes modal.
    document.onkeydown = (e) => {
      let targetModal = "";
      const elKeywordBody = document.getElementById("keywordBody");
      const elNeedHelp = document.getElementById("needHelp");
      const elCoverageDetails = document.getElementById("coverageDetailsTitle");
      if(elKeywordBody && elKeywordBody.offsetWidth!==0){ targetModal="keywordBody";}
      else if (elNeedHelp && elNeedHelp.offsetWidth!==0) {targetModal="needHelp";}
      else if (elCoverageDetails && elCoverageDetails.offsetWidth!==0) { targetModal="coverageDetailsTitle";}
      if(targetModal!==""){
        if (e.which === 9) {
          if(targetModal==="keywordBody"||targetModal==="needHelp") {
            document.getElementById(targetModal).parentNode.parentNode.childNodes[0].childNodes[0].focus();
            e.preventDefault();
          }
          else if (targetModal==="coverageDetailsTitle"){
            if(document.activeElement===document.getElementById("btnCDViewCertificate")&&!e.shiftKey||
              document.activeElement===document.getElementById("btnCDClose")&&e.shiftKey){
              e.preventDefault();
            }
          }
        } else if (e.which === 27) {
          this.modalVisible=false;
          this.coverageDetailsVisible=false;
        }
      }
    };
  },
  watch:{
      $route (to, from){
          this.updateNavButtons(to.path);
        if (to.path !== "/" && to.query && Object.keys(to.query).length > 0) {
        this.$router.replace({ path: to.path, query: {} });
        }
      },
      coverageDetailsVisible(newValue) {
          this.permitFieldFocusWithKeyboardOnQuote(!newValue);
      }
  },
  methods:{
    updateNavButtons(target){
      // Get all navigation elements with null checks
      const navPrevious = document.getElementById("nav_previous");
      const navNext = document.getElementById("nav_next");
      const navPreviousCenter = document.getElementById("nav_previouscenter");
      const navCompleteOrder = document.getElementById("nav_completeorder");
      const navLetsGetStartedWrapper = document.getElementById("nav_letsgetstartedwrapper");
      const navLetsGetStartedWrapper2 = document.getElementById("nav_letsgetstartedwrapper2");
      const navPrintConfirmation = document.getElementById("nav_printconfirmation");

      // Hide all navigation buttons
      if (navPrevious) navPrevious.classList.add("d-none");
      if (navNext) navNext.classList.add("d-none");
      if (navPreviousCenter) navPreviousCenter.classList.add("d-none");
      if (navCompleteOrder) navCompleteOrder.classList.add("d-none");
      if (navLetsGetStartedWrapper) navLetsGetStartedWrapper.classList.add("d-none");
      if (navLetsGetStartedWrapper2) navLetsGetStartedWrapper2.classList.add("d-none");
      if (navPrintConfirmation) navPrintConfirmation.classList.add("d-none");

      // Show appropriate buttons based on route
      if(target==="/"){
        if (navLetsGetStartedWrapper) navLetsGetStartedWrapper.classList.remove("d-none");
        if (navLetsGetStartedWrapper2) navLetsGetStartedWrapper2.classList.remove("d-none");
      }
      else if (target==="/Quote"){
        if (navPreviousCenter) navPreviousCenter.classList.remove("d-none");
      }
      else if (target==="/PaymentInfo"){
        if (navCompleteOrder) navCompleteOrder.classList.remove("d-none");
        if (navPrevious) navPrevious.classList.remove("d-none");
      }
      else if (target==="/Confirmation"){
        if (navPrintConfirmation) navPrintConfirmation.classList.remove("d-none");
      }
      else {
        if (navNext) navNext.classList.remove("d-none");
        if (navPrevious) navPrevious.classList.remove("d-none");
      }
    },
    closeModal(){
      this.focusBack.focus();
      this.modalVisible=false;
    },
    closeCoverageDetails(){
      this.coverageDetailsVisible=false;
      this.focusBack.focus();
    },
    openInNewWindow(url, width, height) {
      const popupWidth = width == null ? 500 : width;
      const popupHeight = height == null ? 600 : height;
      const newWindow = window.open(
        url,
        "popup",
        "scrollbars=1,resizable=1,width=" +
          popupWidth +
          ",height=" +
          popupHeight
      );
    },
    permitFieldFocusWithKeyboardOnQuote(permit) {
        for (var i = 0; i < document.getElementsByClassName("moreDetails").length; i++) {
            document.getElementsByClassName("moreDetails")[i].tabIndex = permit ? 0 : -1;
            document.getElementsByClassName("moreDetails")[i].ariaHidden = !permit;
        }

        for (var i = 0; i < document.getElementsByClassName("btn btn-select").length; i++) {
            if (document.getElementsByClassName("btn btn-select")[i].id != "btnCDSelect") {
                document.getElementsByClassName("btn btn-select")[i].tabIndex = permit ? 0 : -1;
                document.getElementsByClassName("btn btn-select")[i].ariaHidden = !permit;
            }
        }

        for (var i = 0; i < document.getElementsByClassName("botNavLink row no-gutters").length; i++) {
            document.getElementsByClassName("botNavLink row no-gutters")[i].tabIndex = permit ? 0 : -1;
            document.getElementsByClassName("botNavLink row no-gutters")[i].ariaHidden = !permit;
        }

        if (document.getElementById("languagePicker") != null) {
            document.getElementById("languagePicker").tabIndex = permit ? 0 : -1;
            document.getElementById("languagePicker").ariaHidden = !permit;
        }

        for (var i = 0; i < document.getElementsByClassName("link_footer").length; i++) {
            document.getElementsByClassName("link_footer")[i].tabIndex = permit ? 0 : -1;
            document.getElementsByClassName("link_footer")[i].ariaHidden = !permit;
        }

        for (var i = 0; i < document.getElementsByClassName("footerLink").length; i++) {
            document.getElementsByClassName("footerLink")[i].tabIndex = permit ? 0 : -1;
            document.getElementsByClassName("footerLink")[i].ariaHidden = !permit;
        }

        for (var i = 0; i < document.getElementsByClassName("btnHelp form-control").length; i++) {
            document.getElementsByClassName("btnHelp form-control")[i].tabIndex = permit ? 0 : -1;
            document.getElementsByClassName("btnHelp form-control")[i].ariaHidden = !permit;
        }

        if (document.getElementById("footer1_complaint_link") != null) {
            document.getElementById("footer1_complaint_link").tabIndex = permit ? 0 : -1;
            document.getElementById("footer1_complaint_link").ariaHidden = !permit;
        }
    }
  }
}
</script>

<style src="./css/bootstrap.css"></style>
<style src="./css/main.css"></style>
<style src="./css/main_shared.css"></style>
<style src="./css/responsive.css"></style>
<style src="./css/customSelect.css"></style>
<style src="./css/digita11yaccessible.css"></style>